import styled from "styled-components";

export const Body = styled.div`
  padding: 22px 20px calc(20px + env(safe-area-inset-bottom));
  text-align: center;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const IconBadge = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: #fbeae7;
  color: #c0392b;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
`;

export const Title = styled.div`
  font-weight: 900;
  font-size: 17px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Message = styled.div`
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 6px;
  line-height: 1.4;
`;

export const Actions = styled.div`
  display: flex;
  gap: 11px;
  margin-top: 20px;
`;
